import React from 'react';

const SkillsAssessment = ({ domainSkillsList = [], primaryColor = '#1e3a8a' }) => {
  if (!domainSkillsList || domainSkillsList.length === 0) {
    return null;
  }

  const list = domainSkillsList;

  return (
    <div style={{ marginBottom: '16px', background: '#faf5ff', border: '1px solid #e9d5ff', borderRadius: '8px', padding: '12px 14px' }}>
      <h4 style={{ margin: '0 0 8px 0', fontSize: '11px', fontWeight: '700', color: '#6b21a8', textTransform: 'uppercase' }}>
        🌟 Developmental Skills & Personal Abilities
      </h4>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px', fontSize: '11px' }}>
        {list.map((ds, idx) => (
          <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 10px', background: '#ffffff', borderRadius: '4px', border: '1px solid #f3e8ff' }}>
            <span style={{ fontWeight: '600', color: '#374151' }}>{ds.category || '—'}</span>
            <span style={{ fontWeight: '800', color: '#7e22ce', background: '#f3e8ff', padding: '2px 8px', borderRadius: '4px' }}>{ds.rating || '—'}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillsAssessment;
